import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../../helpers/JsonMapper";
import CheckoutFormFieldCollection from "./CheckoutFormFieldCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class CheckoutFormSettings extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [CheckoutFormSettings.payment_method_attribute_name]: CheckoutFormSettings.COD_PAYMENT_METHOD,
      [CheckoutFormSettings.form_length_attribute_name]: CheckoutFormSettings.SHORT_CHECKOUT,
      [CheckoutFormSettings.form_fields_attribute_name]: CheckoutFormFieldCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getPaymentMethodAttributeName() {
    return this.payment_method_attribute_name;
  }
  static getFormLengthAttributeName() {
    return this.form_length_attribute_name;
  }
  static getFormFieldsAttributeName() {
    return this.form_fields_attribute_name;
  }
  getPaymentMethod() {
    return this.getAttribute(CheckoutFormSettings.payment_method_attribute_name);
  }
  isCardPayment() {
    return this.getPaymentMethod() === CheckoutFormSettings.CARD_PAYMENT_METHOD;
  }
}
_defineProperty(CheckoutFormSettings, "COD_PAYMENT_METHOD", 'cod');
_defineProperty(CheckoutFormSettings, "CARD_PAYMENT_METHOD", 'card');
_defineProperty(CheckoutFormSettings, "CUSTOM_PAYMENT_METHOD", 'custom');
_defineProperty(CheckoutFormSettings, "SHORT_CHECKOUT", 'short');
_defineProperty(CheckoutFormSettings, "LONG_CHECKOUT", 'long');
_defineProperty(CheckoutFormSettings, "CUSTOM_CHECKOUT", 'custom');
_defineProperty(CheckoutFormSettings, "NAME_FIELD", 'name');
_defineProperty(CheckoutFormSettings, "PHONE_NUMBER_FIELD", 'phone_number');
_defineProperty(CheckoutFormSettings, "ADDRESS_FIELD", 'address');
_defineProperty(CheckoutFormSettings, "ZIP_CODE_FIELD", 'zip_code');
_defineProperty(CheckoutFormSettings, "REGION_FIELD", 'region');
_defineProperty(CheckoutFormSettings, "CUSTOM_REGION_FIELD", 'custom_region');
_defineProperty(CheckoutFormSettings, "CITY_FIELD", 'city');
_defineProperty(CheckoutFormSettings, "CUSTOM_CITY_FIELD", 'custom_city');
_defineProperty(CheckoutFormSettings, "COUNTRY_FIELD", 'country');
_defineProperty(CheckoutFormSettings, "EMAIL_FIELD", 'email');
_defineProperty(CheckoutFormSettings, "payment_method_attribute_name", 'payment_method');
_defineProperty(CheckoutFormSettings, "form_length_attribute_name", 'form_length');
_defineProperty(CheckoutFormSettings, "form_fields_attribute_name", 'form_fields');